import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiCreateaccountIsaccountavailableMutationRequest,
  PostApiCreateaccountIsaccountavailableMutationResponse,
  PostApiCreateaccountIsaccountavailable401,
  PostApiCreateaccountIsaccountavailable403,
} from "../../../types/PostApiCreateaccountIsaccountavailable";

export function getPostApiCreateaccountIsaccountavailableUrl() {
  return `/api/CreateAccount/IsAccountAvailable` as const;
}

/**
 * {@link /api/CreateAccount/IsAccountAvailable}
 */
export async function postApiCreateaccountIsaccountavailable(
  data?: PostApiCreateaccountIsaccountavailableMutationRequest,
  config: Partial<
    RequestConfig<PostApiCreateaccountIsaccountavailableMutationRequest>
  > & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiCreateaccountIsaccountavailableMutationResponse,
    ResponseErrorConfig<
      | PostApiCreateaccountIsaccountavailable401
      | PostApiCreateaccountIsaccountavailable403
    >,
    PostApiCreateaccountIsaccountavailableMutationRequest
  >({
    method: "POST",
    url: getPostApiCreateaccountIsaccountavailableUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
